import {Link} from 'react-router-dom';
import React, {useMemo} from 'react';
import {toCurrency, toPoints, formatDate} from '@/shared/helpers'

export const TABLE_COLUMNS = [

  {
    Header: "Program Name",
    accessor: "program_name",
    width: 130,
  },
  {
    Header: "Program Id",
    accessor: "program_id",
    width: 95
  },
  {
    Header: "External Id",
    accessor: "external_id",
    width: 95
  },
  {
    Header: "Org ID",
    accessor: "organization_id",
    width: 80
  },
  {
    Header: "First Name",
    accessor: "first_name",
    width: 100
  },
  {
    Header: "Last Name",
    accessor: "last_name",
    width: 100
  },
  {
    Header: "Email",
    accessor: "u_email",
    width: 80
  },
  {
    Header: "Award Event",
    accessor: "event_name",
    width: 80
  },
  {
    Header: "Award Amount",
    accessor: "award_amount",
    Cell: ({ row, value }) => { return toCurrency(value); },
    width: 110
  },
  {
    Header: "Failed Award Date",
    accessor: "created_at",
  },
  {
    Header: "Failed Reason",
    accessor: "failed_reason",
  },
]

